export default function Beneficios() {
  const beneficios = [
    {
      icon: 'ri-volume-up-fill',
      title: 'High gain realista e agressivo',
      description: 'Som brutal com a resposta dinâmica de amplificadores reais'
    },
    {
      icon: 'ri-equalizer-fill',
      title: 'Resposta dinâmica de amp real',
      description: 'Reage à sua palhetada como um amplificador valvulado'
    },
    {
      icon: 'ri-sound-module-fill',
      title: 'Low end firme, médios definidos',
      description: 'Graves controlados, médios presentes e agudos sem estridência'
    },
    {
      icon: 'ri-music-fill',
      title: 'Funciona em drop tunings',
      description: 'Perfeito para afinações baixas sem perder definição'
    },
    {
      icon: 'ri-fire-fill',
      title: 'Metal, hardcore, thrash, death',
      description: 'Ideal para todos os estilos de música pesada'
    },
    {
      icon: 'ri-mic-fill',
      title: 'Pronto para palco e gravação',
      description: 'Use direto na mesa de som ou interface de áudio'
    }
  ];

  return (
    <section className="relative py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Por que escolher o<br />
            <span className="text-orange-500">AMPERO II CAPTURES?</span>
          </h2>
          <p className="text-xl text-gray-400">
            Tone profissional sem complicação
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {beneficios.map((beneficio, index) => (
            <div
              key={index}
              className="group relative bg-zinc-950 border border-zinc-800 hover:border-orange-500/50 p-8 transition-all duration-300 hover:transform hover:scale-105 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 group-hover:bg-orange-500/20 transition-colors duration-300 mb-6">
                <i className={`${beneficio.icon} text-3xl text-orange-500`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-white mb-3 leading-tight">
                {beneficio.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {beneficio.description}
              </p>

              {/* Checkmark */}
              <div className="absolute top-6 right-6 w-8 h-8 flex items-center justify-center bg-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-check-line text-xl text-black font-bold"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
